import { Box, TextField, Autocomplete as MuiAutocomplete, Chip } from '@mui/material'
import { autocompleteClasses } from '@mui/material/Autocomplete'
import DoneIcon from '@mui/icons-material/Done'
import { SerializedStyles } from '@emotion/react'

type AutocompleteProps = {
  options: string[]
  value: string[]
  onChange: (event: React.SyntheticEvent, value: string[]) => void
  labelsMap?: Record<string, string>
  small?: boolean
  limitTags?: number
  customStyles?: Record<string, string | number> | SerializedStyles
  fixedOptions?: string[]
}

const smallStyles = {
  width: 308,
  [`& .${autocompleteClasses.inputRoot}`]: {
    minHeight: '36px',
    maxHeight: '36px',
    flexWrap: 'nowrap',
  },
}

const largeStyles = {
  width: 600,
  [`& .${autocompleteClasses.inputRoot}`]: {
    minHeight: '42px',
    maxHeight: '42px',
    flexWrap: 'nowrap',
  },
}

const styles = {
  [`& .${autocompleteClasses.tag}`]: {
    height: '22px',
    fontSize: '11px',
    fontWeight: '500',
    margin: '1px',
    maxWidth: '80px',
  },
  [`& .${autocompleteClasses.input}`]: {
    minWidth: '60px',
  },
}

export const Autocomplete = ({
  small,
  value,
  options,
  onChange,
  labelsMap,
  customStyles,
  fixedOptions = [],
  limitTags = 2,
}: AutocompleteProps) => {
  return (
    <MuiAutocomplete
      multiple
      limitTags={limitTags}
      size="small"
      options={options}
      sx={
        small
          ? { ...styles, ...smallStyles, ...customStyles }
          : { ...styles, ...largeStyles, ...customStyles }
      }
      onChange={(_, value) => onChange(_, value)}
      value={value}
      renderOption={(props, option, { selected }) => {
        const { key, ...optionProps } = props
        return (
          <li key={key} {...optionProps} style={{ textAlign: 'left' }}>
            <Box
              component={DoneIcon}
              sx={{ width: 17, height: 17, mr: '5px', ml: '-2px' }}
              style={{
                visibility: selected ? 'visible' : 'hidden',
              }}
            />
            <Box
              sx={(t) => ({
                flexGrow: 1,
                '& span': {
                  color: '#8b949e',
                  ...t.applyStyles('light', {
                    color: '#586069',
                  }),
                },
              })}
            >
              {option}
              <br />
              <span>{labelsMap ? labelsMap[option] : ''}</span>
            </Box>
          </li>
        )
      }}
      renderValue={(values, getItemProps) =>
        values.map((option, index) => {
          const { key, ...itemProps } = getItemProps({ index })
          return (
            <Chip
              key={key}
              label={option}
              {...itemProps}
              disabled={fixedOptions.includes(option)}
            />
          )
        })
      }
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={''}
          name="role"
          aria-describedby="roleHelp"
          variant="outlined"
          label=""
        />
      )}
    />
  )
}
